import initialState from "./initialState";
import { insightListingTypes } from "@/enums/insights";

const mutations = {
  setInsightPackages: (state, packages) => {
    state.packages = packages.map(packet => {

      packet.priorityCounts.Opportunity += packet.priorityCounts.Report

      return packet;

    });

    state.packages = packages;
  },
  setInsights: (state, insights) => (state.insights = insights),
  removeInsights: state => state.insights = initialState().insights,
  setPackageInsights: (state, insights) => (state.packageInsights = insights),
  removePackageInsights: (state) => state.packageInsights = initialState().packageInsights,
  changeInsightStatusByType: (state, data) => {
    if (data.listType == insightListingTypes.myInsights) {

      const insightIndex = state.insights.insights.findIndex(insight => insight.insightID == data.insightID);

      if (insightIndex != -1) {
        state.insights.insights[insightIndex][data.type] = data.status;
      }

    } else if (data.listType == insightListingTypes.packageDetail) {

      const insightIndex = state.packageInsights.insights.findIndex(insight => insight.insightID == data.insightID);

      if (insightIndex != -1) {
        state.packageInsights.insights[insightIndex][data.type] = data.status;
      }

    }
  },
  changeIgnoredLastInsight: (state, data) => (state.ignoredLastInsight = data),
  setExploreInsightsFilter:(state,filter)=>{
    if(filter.hasOwnProperty('activeCollection'))state.exploreInsightsFilter.activeCollection=filter.activeCollection;
    if(filter.hasOwnProperty('category'))state.exploreInsightsFilter.category=filter.category;
    if(filter.hasOwnProperty('listingOption'))state.exploreInsightsFilter.listingOption=filter.listingOption;
    if(filter.hasOwnProperty('isActiveRemoveFilterBtn'))state.exploreInsightsFilter.isActiveRemoveFilterBtn=filter.isActiveRemoveFilterBtn;
  },
  removeExploreInsightsFilter: (state) => {
    state.exploreInsightsFilter = {
      activeCollection: {},
      category: '',
      listingOption: "all",
      isActiveRemoveFilterBtn: false,
    }
  },
  setRunningPackageData: (state, pckg) => state.runningPackagesData[pckg.reportID] = pckg,
  setRunningPackagePercent: (state, pckg) => {
    if (!state.runningPackagesData[pckg.reportID]) return;

    state.runningPackagesData[pckg.reportID].percent = pckg.percent
  },
  removeRunnedPackageData: (state, packet) => {
    const { [packet.reportID]: dynamickey, ...packages } = state.runningPackagesData;
    state.runningPackagesData = packages;
  },
  setRunnedPackage: (state, packet) => state.runnedPackages.push(packet),
  removeRunnedPackage: (state, packet) => {
    state.runnedPackages = state.runnedPackages.filter(pckg => pckg.reportID != packet.reportID);
  },
  resetModule:(state)=>(Object.assign(state, initialState())),
  setPackageRunningStatus:(state,pckg)=>state.isRunPackage=pckg,
  setSearchedInsightsResults:(state,results)=>state.searchedInsightsResults=results,
  setInsightSearchText:(state,text)=>state.insightSearchText=text,
  removeSearchedInsightsResults:(state)=>state.searchedInsightsResults=[],
  removeInsightSearchText: (state) => state.insightSearchText = '',
  setWeeklyInsightChanges: (state, weeklyInsightChanges) => state.weeklyInsightChanges = weeklyInsightChanges,
  setSortedInsights: (state, insights) => state.sortedInsights = insights,
  removeSortedInsights: (state, insights) => state.sortedInsights = [],
};

export default mutations



// WEBPACK FOOTER //
// ./src/store/modules/insights/mutations.js